


























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { scrollModalIntoView } from '../Modal/ModalMantenedor.vue';
import InformeEventBus from '@/pantallas/Informes/partes/InformeEventBus';
import { isPasoValido } from './isPasoValido';

type Value = number;

@Component({})
export default class CrudStepsNavBar extends Vue {
  /**
   * Índice del paso activo
   */
  @Prop({ required: true }) value: Value;
  @Prop({ required: true }) pasos: PasosCrud;
  /**
   * Pasos en "Ver detalle" no validan, tampoco tienen un validador de
   * v-validate asignado.
   */
  @Prop({ default: true }) validarPaso: boolean;

  pasoActivoIndex: Value = this.value;

  @Watch('pasoActivoIndex')
  async handleValueChange(
    pasoActivoIndex: Value,
    previousPasoActivoIndex: Value
  ) {
    if (this.validarPaso) {
      if (!(await isPasoValido(this.getPaso(previousPasoActivoIndex)))) {
        this.pasoActivoIndex = previousPasoActivoIndex;
        return;
      }
    }
    this.$emit('input', this.pasoActivoIndex);
  }

  async handleStepClick() {
    // Asume que es usado dentro de un <ModalMantenedor>
    scrollModalIntoView();
  }

  getPaso(index: number) {
    return Object.values(this.pasos).find(x => x.step === index);
  }
}
